import RetailApiV2 from '@/api/retailApi/RetailApiV2'

export interface ProductSubCategory {
  id: number
  title: string
  permalink: string
  systemName: string
}

export interface ProductCategory {
  id: number
  title: string
  permalink: string
  systemName: string
  image: string
  description: string
  ogTitle: string
  ogDescription: string
  subcategories: ProductSubCategory[]
}

export interface EventCategory {
  id: number
  title: string
  permalink: string
  systemName: string
  image: string
  description: string
  ogTitle: string
  ogDescription: string
}

interface ProductCategoriesResponse {
  categories: ProductCategory[]
  eventCategories: EventCategory[]
}

export class CategoryService {
  private cache: ProductCategoriesResponse | null = null

  private async fetch(): Promise<ProductCategoriesResponse> {
    if (this.cache) return this.cache
    const { data } = await RetailApiV2.get('products_categories') as { data: ProductCategoriesResponse }
    this.cache = data
    return this.cache
  }

  async loadProductsCategories(): Promise<ProductCategory[]> {
    return (await this.fetch()).categories ?? []
  }

  async loadEventCategories(): Promise<EventCategory[]> {
    return (await this.fetch()).eventCategories ?? []
  }
}

export const categoryService = new CategoryService()
